import script from "./SideMenuTargetReasonsTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenuTargetReasonsTooltip.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__